import { render, staticRenderFns } from "./TopBuyerCities.vue?vue&type=template&id=e93938f6&"
import script from "./TopBuyerCities.vue?vue&type=script&lang=js&"
export * from "./TopBuyerCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports